import useAppToast from '@/hooks/useAppToast';
import { createRezeptSheet } from '@/services/admin/rezeptSheetService';
import type { CreateRezeptSheetPayload } from '@/types/admin-rezept-sheet';
import { getApiErrorMessage } from '@/utils/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useCreateRezeptSheet = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: CreateRezeptSheetPayload) => createRezeptSheet(currentSite, data),
    onSuccess: async () => {
      toast.success('更新しました。');
      await queryClient.invalidateQueries({ queryKey: ['rezept-sheets', currentSite] });
    },
    onError: error => {
      toast.error(getApiErrorMessage(error, 'エラーが発生しました。'));
    },
  });

  return { createRezeptSheet: mutateAsync, isPending };
};
